import SignupWrapper from "../MultiSectionSignup/signupWrapper";
import SignupV2Wrapper from "../MultiSectionSignup/signupV2Wrapper";
import { useLoginSuccess } from "../Hook/useLoginSuccess";

const SignUpPageWrapper = ({version = 1}) => {
    useLoginSuccess();

    if (version === 1) {
        return <SignupWrapper/>;
    } else {
        return <SignupV2Wrapper/>
    }
}

export default SignUpPageWrapper;
